function Accordions() {
  const accordions = document.getElementsByClassName('accordion');
  for (let i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener('click', (e) => {
      e.preventDefault();
      const element = e.currentTarget;
      element.classList.toggle('active');
      const panel = element.nextElementSibling;
      if (panel) {
        if (panel.style.maxHeight) {
          panel.style.maxHeight = '';
        } else {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      }
    });
  }
}

export default Accordions;
